import { Card, Inline, Stack, vars, Text, textVariants } from '@etg/wings';
import { EventSegmentType } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { ShieldCheck } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { Icon } from '@eti/components';

const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;

const iconStyles = css`
  flex: 0 0 auto;
`;

const selfTransferEventType = EventSegmentType.SelfTransfer;

const ItineraryTripDetailsSelfTransferCard = () => {
  const { t } = useTranslation();

  return (
    <Card className={cardStyles} role="listitem">
      <Stack data-testid={`trip-event-${selfTransferEventType}`} spacing={8}>
        <Inline alignY="center" noWrap spacing={4}>
          <Icon
            aria-hidden
            color={vars.colors.promotional.foreground}
            data-testid="self-transfer-icon"
            id="self-transfer"
            size="20px"
          />
          <Text
            data-testid={`trip-event-${selfTransferEventType}-title`}
            variant={textVariants._14_BOLD}
          >
            {t('IbeClient.Itinerary.Drawer.TripDetails.SelfTransfer.Card.Title')}
          </Text>
        </Inline>
        <Stack>
          <Card.Section>
            <Text asHtml>
              {t('IbeClient.Itinerary.Drawer.TripDetails.SelfTransfer.Card.FirstSection.Text')}
            </Text>
          </Card.Section>
          <Inline noWrap spacing={8}>
            <ShieldCheck
              aria-hidden
              className={iconStyles}
              color={vars.colors.signal.positive.light}
              size={20}
              weight="fill"
            />
            <Text asHtml>
              {t('IbeClient.Itinerary.Drawer.TripDetails.SelfTransfer.Card.SecondSection.Text')}
            </Text>
          </Inline>
        </Stack>
      </Stack>
    </Card>
  );
};

export default ItineraryTripDetailsSelfTransferCard;
